<template>
  <!-- 患者情報詳細 -->
  <div id="AppPatientDetailSleep">
    <!-- 上部余白 -->
    <div style="height: 10px" />

    <div style="margin-left: 50px; margin-right: 50px">
      <!-- 画面タイトル -->
      <div class="columns">
        <div class="column">
          <label class="searchTitle label">患者情報詳細</label>
        </div>
      </div>

      <!-- 詳細表示 -->
      <div style="detailArea">
        <table class="table is-full">
          <table style="width: 100%">
            <tr>
              <th style="border-bottom: solid 1px; width: 180px">患者コード</th>
              <td style="border-bottom: solid 1px" colspan="8">
                <div style="float: left">
                  <span :class="interestPatientClass">
                    {{ data.patientCode }}
                  </span>
                  <template v-if="data.interestPatient">
                    <b-icon icon="account-alert" type="is-danger"> </b-icon>
                  </template>
                  <template v-if="data.followUpCall">
                    <b-icon icon="volume-high" type="is-info"> </b-icon>
                    <span class="has-text-info">フォローアップコール</span>
                  </template>
                </div>
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">患者名（患者名カナ）</th>
              <td style="border-bottom: solid 1px" colspan="8">
                <span :class="interestPatientClass">
                  {{ data.patientName }}
                </span>
                <span v-if="data.patientNameKana" :class="interestPatientClass">
                  （{{ data.patientNameKana }}）
                </span>
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">住所</th>
              <td style="border-bottom: solid 1px" colspan="8">
                〒{{ data.postCode }} {{ data.address }}
                <b-field class="file" style="float: right">
                  <b-button
                    class="button is-primary has-text-centered"
                    icon-left="google-maps"
                    native-type="button"
                    v-on:click="
                      doShowGoogleMap([
                        {
                          address: data.address,
                          name: data.patientName,
                          patientZipCode: data.postCode,
                        },
                      ])
                    "
                  ></b-button>
                  <googleMap-form
                    v-model="isShowGoogleMap"
                    v-bind:marker="addressList"
                  ></googleMap-form>
                </b-field>
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">電話</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ data.phoneNumber }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">携帯電話</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ data.mobilePhoneNumber }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">緊急連絡先</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ data.emergencyContact }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">勤務先名</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ data.employment }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">勤務連絡先</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ data.employmentContact }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">誕生日</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ data.birthday }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">年齢</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ calcAge }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">性別</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ data.gender | genderFilter }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">疾患名</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ data.diseaseName }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">感染症</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ data.infection | infectionFilter }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">直送先種別</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ data.directDestinationType | directDestinationTypeFilter }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">リースアップ種別</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ leaseupTypes }}
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">
                ドリームマッパー（アプリ）
              </th>
              <td style="border-bottom: solid 1px" colspan="8">
                <span v-if="data.dreamMapper">使用する</span>
              </td>
            </tr>

            <tr>
              <th style="border-bottom: solid 1px">診察券番号（備考１）</th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{ data.patientTicketNumber }}
              </td>
            </tr>

            <template v-for="(productDetail, index) in data.productDetails">
              <tr :key="'expendable_' + index">
                <th
                  style="border-bottom: solid 1px"
                  :rowspan="
                    expendablesRowspan(
                      productDetail.expendables.expendableDetails
                    )
                  "
                >
                  消耗品情報{{ index + 1 }}
                </th>
                <th style="border-bottom: solid 1px; width: 230px">
                  前回消耗品供給日
                </th>
                <td style="border-bottom: solid 1px" colspan="6">
                  {{ productDetail.expendables.consumablesSupplyLastDate }}
                  <span
                    v-if="productDetail.expendables.isSupplyLeaked"
                    style="color: red"
                  >
                    供給漏れ
                  </span>
                </td>
              </tr>
              <template
                v-for="(expendable, index2) in productDetail.expendables
                  .expendableDetails"
              >
                <tr :key="'expendableRow1_' + index + '_' + index2">
                  <th
                    style="border-bottom: solid 1px"
                    :rowspan="expendableRowspan(expendable)"
                  >
                    {{ expendable.type | expendableFilter }}
                  </th>
                  <template
                    v-if="
                      expendable.type == expendableTypes.mask.code ||
                      expendable.type == expendableTypes.chamber.code
                    "
                  >
                    <th style="border-bottom: solid 1px; width: 110px">
                      品目名
                    </th>
                    <td style="border-bottom: solid 1px" colspan="6">
                      {{ expendable.productName }}
                    </td>
                  </template>
                  <template v-else>
                    <th style="border-bottom: solid 1px; width: 110px">
                      チューブタイプ
                    </th>
                    <td style="border-bottom: solid 1px" colspan="6">
                      {{ expendable.productName }}
                    </td>
                  </template>
                </tr>

                <tr
                  v-if="
                    expendable.type == expendableTypes.mask.code ||
                    expendable.type == expendableTypes.chamber.code
                  "
                  :key="'expendableRow2_' + index + '_' + index2"
                >
                  <th style="border-bottom: solid 1px">品目コード</th>
                  <td style="border-bottom: solid 1px" colspan="6">
                    {{ expendable.productCode }}
                  </td>
                </tr>

                <tr
                  v-if="expendable.type == expendableTypes.mask.code"
                  :key="'expendableRow3_' + index + '_' + index2"
                >
                  <th style="border-bottom: solid 1px">サイズ</th>
                  <td style="border-bottom: solid 1px" colspan="6">
                    {{ expendable.size }}
                  </td>
                </tr>
              </template>
            </template>

            <tr
              v-for="(
                hospitalTransferHistory, index
              ) in data.changeHospitalList"
              :key="'hospitalTransferHistory_' + index"
            >
              <th
                v-if="index == 0"
                style="border-bottom: solid 1px"
                :rowspan="data.changeHospitalList.length"
              >
                転院履歴
              </th>
              <td style="border-bottom: solid 1px" colspan="8">
                {{
                  hospitalTransferHistory.moveOutData +
                  "（" +
                  hospitalTransferHistory.hospitalName +
                  "）"
                }}
              </td>
            </tr>

            <template v-for="(productDetail, index) in data.productDetails">
              <tr :key="'productDetail1_' + index">
                <th style="border-bottom: solid 1px" rowspan="10">
                  機器情報{{ index + 1 }}
                </th>
                <th style="border-bottom: solid 1px; width: 230px">
                  機器機械名
                </th>
                <td style="border-bottom: solid 1px" colspan="7">
                  {{
                    productDetail.productName +
                    "（" +
                    productDetail.productCode +
                    "）"
                  }}
                  <div style="float: right">
                    <b-button
                      style="float: right; margin-right: 0.2em"
                      class="button is-primary has-text-centered"
                      native-type="button"
                      v-on:click="gotoPrescriptionRef(index)"
                      position="is-right"
                    >
                      処方値参照
                    </b-button>
                  </div>
                </td>
              </tr>

              <tr :key="'productDetail2_' + index">
                <th style="border-bottom: solid 1px">シリアルNo.</th>
                <td style="border-bottom: solid 1px" colspan="7">
                  {{ productDetail.serialNumber }}
                </td>
              </tr>

              <tr :key="'productDetail3_' + index">
                <th style="border-bottom: solid 1px">
                  医療機関名（医療機関得意先コード）
                </th>
                <td style="border-bottom: solid 1px" colspan="7">
                  {{
                    productDetail.hospitalName +
                    "（" +
                    productDetail.hospitalCode +
                    "）"
                  }}
                </td>
              </tr>

              <tr :key="'productDetail4_' + index">
                <th style="border-bottom: solid 1px">診療科 担当医</th>
                <td style="border-bottom: solid 1px" colspan="7">
                  {{ productDetail.department }}
                  ({{ productDetail.doctorName }})
                </td>
              </tr>

              <tr :key="'productDetail5_' + index">
                <th style="border-bottom: solid 1px">医療機関電話番号</th>
                <td style="border-bottom: solid 1px" colspan="7">
                  {{ productDetail.hospitalPhone }}
                </td>
              </tr>

              <tr :key="'productDetail6_' + index">
                <th style="border-bottom: solid 1px">直通電話番号</th>
                <td style="border-bottom: solid 1px" colspan="7">
                  {{ productDetail.directPhone }}
                </td>
              </tr>

              <tr :key="'productDetail7_' + index">
                <th style="border-bottom: solid 1px">営業所名</th>
                <td style="border-bottom: solid 1px" colspan="7">
                  {{ productDetail.officeCode | officeFilter(officeMaster) }}
                </td>
              </tr>

              <tr :key="'productDetail8_' + index">
                <th style="border-bottom: solid 1px">担当名</th>
                <td style="border-bottom: solid 1px" colspan="7">
                  {{ productDetail.staffName }}({{productDetail.staffCode}})
                </td>
              </tr>

              <tr :key="'productDetail9_' + index">
                <th style="border-bottom: solid 1px">顧客出荷日</th>
                <td style="border-bottom: solid 1px" colspan="7">
                  {{ productDetail.customerDeliveryDay }}
                </td>
              </tr>

              <tr :key="'productDetail10_' + index">
                <th style="border-bottom: solid 1px">最終リースアップ予定日</th>
                <td style="border-bottom: solid 1px" colspan="7">
                  {{ productDetail.lastReasupScheduledDay }}
                </td>
              </tr>
            </template>

            <tr>
              <th style="border-bottom: solid 1px">メモ</th>
              <td style="border-bottom: solid 1px" colspan="8">
                <b-input
                  type="textarea"
                  v-model="data.memo"
                  readonly
                  name="memo"
                  data-vv-as="メモ"
                ></b-input>
              </td>
            </tr>
          </table>
        </table>
      </div>
    </div>

    <!-- 余白 -->
    <div style="height: 50px" />

    <!-- 戻るボタン -->
    <div style="text-align: center">
      <b-button
        v-on:click="back()"
        class="button"
        type="is-primary"
        native-type="button"
        icon-left="keyboard-backspace"
        >戻る</b-button
      >
    </div>
    <!-- 下部余白 -->
    <div style="height: 10px" />
  </div>
</template>

<script>
import MapForm from "../components/common/Map.vue";
import * as item from "../utils/item";
import * as patientUtils from "../utils/patient";

export default {
  name: "AppPatientDetailSleep",

  props: {},

  computed: {
    interestPatientClass: function () {
      const interestPatientClass = this.data.isInterestPatient
        ? "has-text-danger"
        : "";
      return interestPatientClass;
    },

    leaseupTypes: function () {
      if (!this.data.leaseUpType) {
        return;
      }

      // 名称取得
      const leaseupTypeInfo = patientUtils.LEASEUP_TYPES.find(
        (elem) => elem.code == this.data.leaseUpType
      );

      return leaseupTypeInfo.name;
    },

    calcAge: function () {
      let age = 0;
      if (this.data.birthday) {
        let nowInt = Number(this.formatDate2(new Date()).replace(/\//g, ""));
        let birthdayInt = Number(this.data.birthday.replace(/\//g, ""));
        age = Math.floor((nowInt - birthdayInt) / 10000);
      }
      return age;
    },
  },

  methods: {
    doShowGoogleMap: function (address) {
      this.addressList = address;
      this.isShowGoogleMap = true;
    },

    expendableRowspan: function (expendable) {
      let rowspan = 0;
      switch (expendable.type) {
        case item.EXPENDABLE_TYPE_MAP.mask.code:
          rowspan = 3;
          break;
        case item.EXPENDABLE_TYPE_MAP.chamber.code:
          rowspan = 2;
          break;
        case item.EXPENDABLE_TYPE_MAP.hose.code:
          rowspan = 1;
          break;
      }
      return rowspan;
    },

    gotoPrescriptionRef: function (productIndex) {
      // 処方値参照
      this.$router.push({
        name: "AppPrescriptionRefSleep",
        params: {
          productIndex: productIndex,
          patient: this.data,
          searchConditions: this.searchConditions,
        },
      });
    },

    back: function () {
      this.$router.push({
        name: "AppPatientSearchSleep",
        params: {
          searchConditions: this.searchConditions,
          patientSearchFlag: true,
        },
      });
    },

    loadData: function () {
      // 患者情報取得
      this.apiCall(
        this.getPatient,
        this.getPatientSuccess,
        this.showErrorMessage,
        this.$store.state.subSystem
      );
      return;
    },

    getPatient: function (client) {
      // 患者情報取得
      const res = client.apis.apiPatient.getPatientGET({
        patientCode: this.$route.params["code"],
      });

      return res;
    },

    getPatientSuccess: function (result) {
      // 患者情報取得結果設定
      this.data = result.obj;
      return;
    },

    expendablesRowspan: function (expendables) {
      let rowspan = 1;
      for (const expendable of expendables) {
        switch (expendable.type) {
          case item.EXPENDABLE_TYPE_MAP.mask.code:
            rowspan += 3;
            break;
          case item.EXPENDABLE_TYPE_MAP.chamber.code:
            rowspan += 2;
            break;
          case item.EXPENDABLE_TYPE_MAP.hose.code:
            rowspan += 1;
            break;
        }
      }
      return rowspan;
    },
  },

  data() {
    const officeMaster = JSON.parse(sessionStorage.getItem("officeMaster"));
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const searchConditions = this.$route.params.searchConditions;

    return {
      officeMaster,
      userInfo,
      data: {
        changeHospitalList: [],
        productDetails: [],
      },
      inspectionItemModalActive: false,
      isShowGoogleMap: false,
      addressList: [],
      searchConditions,
      expendableTypes: item.EXPENDABLE_TYPE_MAP,
    };
  },

  filters: {
    officeFilter: function (value, officeMaster) {
      var officeElement = officeMaster.find((v) => v.officeCode === value);
      if (officeElement) {
        return officeElement.officeName;
      }
      return "";
    },
  },

  created: function () {
    this.loadData();
    return;
  },

  mounted: function () {},

  components: {
    "googleMap-form": MapForm,
  },
};
</script>

<style lang="scss" scoped>
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Set your colors
$primary: #061e57;
$primary-invert: findColorInvert($primary);
$info: #209cee;
$info-invert: findColorInvert($info);
$light: whitesmoke;
$light-invert: findColorInvert($light);
$success: #23d160;
$success-invert: findColorInvert($success);
$danger: #ff3860;
$danger-invert: #fff;
$background: #061e57;

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black,
  ),
  "black": (
    $black,
    $white,
  ),
  "light": (
    $light,
    $light-invert,
  ),
  "dark": (
    $dark,
    $dark-invert,
  ),
  "primary": (
    $primary,
    $primary-invert,
  ),
  "info": (
    $info,
    $info-invert,
  ),
  "success": (
    $success,
    $success-invert,
  ),
  "warning": (
    $warning,
    $warning-invert,
  ),
  "danger": (
    $danger,
    $danger-invert,
  ),
);
</style>



// WEBPACK FOOTER //
// src/components/AppPatientDetailSleep.vue